<template>
	<nav class="Breadcrumbs" :class="classes">
		<ul>
			<!-- @slot CloBreadcrumbsItem goes here -->
			<slot />
		</ul>
	</nav>
</template>

<script>
import CloBreadcrumbsItem from '@/navigation/CloBreadcrumbs/CloBreadcrumbsItem.vue';
export default {
	components: { CloBreadcrumbsItem },
	props: {
		/**
		 * reverse
		 */
		reverse: {
			type: Boolean,
			default: false,
		},
		/**
		 * only choice is sm
		 */
		size: {
			type: String,
			default: null,
		},
		/**
		 * can be caret or pipe
		 */
		separator: {
			type: String,
			default: null,
		},
	},
	computed: {
		classes() {
			return {
				'Breadcrumbs--reverse': this.reverse,
				'Breadcrumbs--sm': this.size === 'sm',
				'Breadcrumbs--pipe': this.separator === 'pipe',
				'Breadcrumbs--caret': this.separator === 'caret',
				'Breadcrumbs--comma': this.separator === 'comma',
			};
		},
	},
};
</script>

<style lang="scss">
/* --------------------------------
	Breadcrumbs
	Displays a list of links inline with > separators
-------------------------------- */

/* Default class - uses ">" as separator */
.Breadcrumbs {
	display: inline-block;
	@include inline-sm;
	@include text(3);
	ul {
		list-style-type: none;
		margin: 0;
		padding: 0;
		display: inline-flex;
		flex-wrap: wrap;
		align-items: baseline;
	}
	li {
		display: inherit; // override foundation list item display
		&:not(:last-child):after {
			color: $color-neutral-3;
			content: '>';
			margin: 0 0.5em;
		}
	}
}

/* ----------------
	Variants
---------------- */

/* Small variant */
.Breadcrumbs--small, .Breadcrumbs--sm {
	@include text(2);
}

/* Pipe variant uses a "|" as separator */
.Breadcrumbs--pipe {
	li {
		&:not(:last-child):after {
			content: '|';
		}
	}
}

/* Comma variant uses a "," as separator */
.Breadcrumbs--comma {
	li {
		&:not(:last-child):after {
			content: ',';
			margin: 0 0.5em 0 0;
			[dir='rtl'] & {
				margin: 0 0 0 0.5em;
			}
		}
	}
}

/* Reverse variant for dark backgrounds */
.Breadcrumbs--reverse {
	li {
		color: $color-text-reverse;
		a {
			color: $color-link-reverse;
		}
		a:hover {
			color: $color-link-hover-reverse;
		}
		&:not(:last-child):after {
			color: $color-neutral-4;
		}
	}
}
</style>
